/**
 * 管理画面のセッションを使える接続か（ADM-17、PR #90 レビュー P2、2026-10-04 方針）。
 *
 * ログイン・更新・ログアウトは、どれもタブ間で共有する同じ Cookie を書き換える。
 * これらは Web Locks でタブ間に1つずつ実行する（config/axiosInstance.ts）。Web Locks は
 * secure context（https か localhost）でしか使えず、直列にできないまま実行すると、
 * 別のタブのログアウトの応答が新しいログインの Cookie を消すなどが起きる。
 * そのため管理画面は secure context で、Web Locks が使えるブラウザでだけ使う。
 */

export type SessionEnvironmentProblem = 'insecure-context' | 'no-web-locks';

export function sessionEnvironmentProblem(): SessionEnvironmentProblem | null {
  if (typeof window === 'undefined' || window.isSecureContext !== true) {
    return 'insecure-context';
  }
  const locks = typeof navigator !== 'undefined' ? (navigator as any).locks : undefined;
  if (!locks || typeof locks.request !== 'function') return 'no-web-locks';
  return null;
}

export function canUseSession(): boolean {
  return sessionEnvironmentProblem() === null;
}
